// Runtime polyfills for browser build
import process from "process";
import { Buffer } from "buffer";

if (!globalThis.process) {
  globalThis.process = process;
}

// Some libs expect these flags
globalThis.process.browser = true;
globalThis.process.version = globalThis.process.version || "v0.0.0";

if (!globalThis.Buffer) {
  globalThis.Buffer = Buffer;
}
